import React from 'react';

const ModuleCard = ({ module, onClick }) => {
  return (
    <div className="event-card" onClick={onClick}>
      <img 
        src={module.cardImage} 
        alt={module.title}
        className="event-image"
      />
      <div className="event-content">
        <h3 className="event-title">{module.title}</h3>
        <p className="event-location">{module.subtitle}</p>
      </div>
    </div>
  );
};

export default ModuleCard;
